import Header from "./Component/Header";
import Footer from "./Component/Footer";

const faqItems = [
    {
        question: "Bagaimana cara melakukan top up?",
        answer: "Kunjungi situs resmi atau aplikasi penyedia. Pilih layanan yang diinginkan (misal: Game, E-Wallet, Pulsa). Masukkan nomor HP atau User ID Game. Pilih nominal top up. Pilih metode pembayaran (Transfer Bank, QRIS, E-wallet, atau Kartu Kredit). Selesaikan pembayaran dan simpan bukti transfer.",
    },
    {
        question: "Metode pembayaran apa saja yang diterima?",
        answer: "Umumnya menerima transfer bank (BCA, BNI, Mandiri), e-wallet (ShopeePay, GoPay, OVO, Dana), QRIS, serta kartu kredit.",
    },
    {
        question: "Berapa lama saldo/produk masuk?",
        answer: "Saldo atau item game biasanya masuk secara instan atau dalam beberapa menit setelah pembayaran berhasil dikonfirmasi sistem.",
    },
    {
        question: "Bagaimana jika saldo tidak masuk setelah transfer?",
        answer: "Periksa riwayat transaksi, jika status sukses tapi barang belum diterima, hubungi Customer Service situs tersebut dengan menyertakan bukti pembayaran (invoice/screenshot).",
    },
    {
        question: "Apakah transaksi top up di website aman?",
        answer: "Selalu pastikan Anda bertransaksi di situs resmi. Periksa keamanan dengan melihat ikon gembok pada URL di browser.",
    },
    {
        question: "Bagaimana jika salah memasukkan nomor/ID tujuan?",
        answer: "Biasanya, kesalahan input nomor/ID tidak dapat dibatalkan atau direfund karena sistem bekerja otomatis. Pastikan memeriksa kembali detail sebelum konfirmasi.",
    },
    {
        question: "Apakah ada biaya tambahan?",
        answer: "Beberapa metode pembayaran (terutama e-wallet atau virtual account) mungkin mengenakan biaya admin kecil atau biaya layanan.",
    },
];

export default function Faq() {
    return (
        <>
            <Header />
            <main id="content" className="max-w-4xl px-4 sm:px-6 lg:px-8 mx-auto py-10 md:py-14">
                <div className="mb-8">
                    <h1 className="text-3xl md:text-4xl font-bold text-foreground">
                        Pertanyaan Umum Seputar Top Up di Website
                    </h1>
                </div>

                <div className="space-y-4">
                    {faqItems.map((item) => (
                        <div key={item.question} className="rounded-xl border border-line-2 bg-layer p-5">
                            <h2 className="question text-lg font-semibold text-foreground">
                                {item.question}
                            </h2>
                            <p className="answer mt-2 text-sm text-muted-foreground-1 leading-relaxed">
                                {item.answer}
                            </p>
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </>
    );
}
